/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $PlayerPosition = {
    properties: {
        key: {
            type: 'PlayerPositionEnum',
            isRequired: true,
        },
        translation: {
            type: 'Translation',
            isRequired: true,
        },
    },
} as const;
